import * as React from 'react';

interface OverflowOptions {
  skipVertical?: boolean;
}

export const useIsOverflow = (
  ref: React.MutableRefObject<any>,
  options: OverflowOptions = undefined,
  callback: any = undefined,
): boolean => {
  const [isOverflow, setIsOverflow] = React.useState(undefined);

  React.useLayoutEffect(() => {
    const { current } = ref;

    const trigger = () => {
      const hasOverflow =
        current.scrollWidth > current.clientWidth ||
        (!options?.skipVertical && current.scrollHeight > current.clientHeight);
      setIsOverflow(hasOverflow);

      if (callback) callback(hasOverflow);
    };

    if (current) {
      if ('ResizeObserver' in window) {
        new ResizeObserver(trigger).observe(current);
      }

      trigger();
    }
  }, [callback, ref, options]);

  return isOverflow;
};
